import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Response } from '@angular/http';
import { Title } from '@angular/platform-browser';
import { CellClickedEvent, CellDoubleClickedEvent, GridApi, GridOptions, GridReadyEvent } from 'ag-grid';
import { constant } from 'app/app.constants';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import {
  AgButtonsEnum,
  DepositAction,
  DepositActions,
  DepositGridName,
  DepositsStatusEnum,
  EventModal,
  ModalNameEnum,
  OptionImportEnum,
  StepperEnum,
  TabsDepositsEnum
} from 'app/core/enums/tabs-deposits.enum';
import { FormatCurrencyHelper } from 'app/core/helpers/format-currency-helper';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { BtnCellRendererI } from 'app/core/interfaces/Btn-cell-renderer.interface';
import { IDeposit, IDepositResponse } from 'app/core/interfaces/deposit.interface';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { BtnCellRendererComponent } from 'app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import * as moment from 'moment';
import { IMyOptions } from 'mydatepicker';
import { Observable, Subscription } from 'rxjs';
import { pairwise } from 'rxjs/operators';

declare const $: any;

@Component({
  selector: 'app-deposits',
  templateUrl: './deposits.component.html',
  styleUrls: ['./deposits.component.scss']
})
export class DepositsComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('modalAddDeposit') modalAddDeposit: T2CardComponent;
  @ViewChild('modalImportDeposit') modalImportDeposit: T2CardComponent;
  @ViewChild('modalCopyPasteDepositDetails') modalCopyPasteDepositDetails: T2CardComponent;
  @ViewChild('modalDepositNote') modalDepositNote: T2CardComponent;
  @ViewChild('modalDepositHistory') modalDepositHistory: T2CardComponent;
  @ViewChild('file') fileInput: ElementRef;
  tabsDeposits = constant.DEPOSITS_POSTING.TABS_DEPOSITS;
  modalDeposits = constant.MODAL_DEPOSITS;
  stepperEnum = constant.STEPPER_DEPOSITS;
  @ViewChild('idSearch') idSearch: ElementRef;
  subscriptions: Subscription[] = [];
  depositSearchForm: FormGroup;
  depositForm: FormGroup;
  lockBoxForm: FormGroup;
  gridDepositHistory: GridOptions;
  gridDepositOptions: GridOptions;
  showMisappliedDeposits: FormControl;
  myRDPOptions: IMyOptions = {
    firstDayOfWeek: 'su',
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true,
    markCurrentDay: false,
  };
  jsonDepositDate: any;
  depositStatusList = [];
  accountList = [];
  statusSelectedList = [];
  accountnumberSelectedList = [];
  totalRows = 0;
  dropdownSettings = {};
  dropdownSettingsAccount = {};
  totalAmount = 0;
  activatedTab = TabsDepositsEnum.Deposits;
  totalCredit = 0;
  totalPostedAmt = 0;
  totalAdjAmt = 0;
  totalDiffAmount = 0;
  totalDepositAmountSelected = 0;
  totalDepositPostAmountSelected = 0;
  totalDepositAdjAmountSelected = 0;
  totalDiffSelected = 0;

  reasonChangeStatus = '';
  optionImport = OptionImportEnum.Deposits;
  previousStatus: number;
  public actionsDeposit = [];
  filteredDataAndSort: any[] = [];
  indexCountStepper = 0;
  agGridButtonActionList = {
    RemoveFilter: AgButtonsEnum.RemoveFilter,
    RemoveSort: AgButtonsEnum.RemoveSort
  };
  enableClearFilter = true;
  enableClearSort = true;
  selectedRowIndex = null;
  noBlankSpace = constant.NO_BLANK_SPACE;
  notengmodel = null;
  showCancelButtonModal = true;
  allDeposits: IDepositResponse[];
  depositsWithoutMisapplied: IDepositResponse[];
  resetDepositStatus = false;


  get showFileInput(): string {
    return '.xls, .xlsx, .csv';
  }

  get idCtrl(): AbstractControl {
    return this.depositSearchForm.get('id');
  }

  get idLblCtrl(): AbstractControl {
    return this.depositSearchForm.get('idlbl');
  }

  get filesNamesCtrl(): AbstractControl {
    return this.depositSearchForm.get('file');
  }

  get showAutoFillButton(): boolean {
    return this.activatedTab === this.tabsDeposits.Detail && this.getCtrlByName('descriptionlbl').value;
  }

  get showAutoFillPayorButton(): boolean {
    return (
      this.activatedTab === this.tabsDeposits.Detail &&
      this.getCtrlByName('depositslist').value &&
      !!this.getCtrlByName('depositslist').value.length
    );
  }

  get accountNumberFormCtrl(): AbstractControl {
    return this.depositForm.get('accountnumber');
  }

  get noteCtrl(): AbstractControl {
    return this.depositSearchForm.get('note');
  }

  get depositStatusColor(): string {
    let response = '';
    const depositStatusId = this.getCtrlByName('depositStatus').value;
    switch (depositStatusId) {
      case DepositsStatusEnum.Completed:
        response = 'complete-color';
        break;
      case DepositsStatusEnum.Pending:
        response = 'pending-color';
        break;
      default:
        response = '';
        break;
    }
    return response;
  }

  get depositStatusColorHeader(): string {
    let response = '';
    const depositStatusId = this.getCtrlByName('depositStatus').value;
    switch (depositStatusId) {
      case DepositsStatusEnum.Completed:
        response = 'bg-balance-title-item';
        break;
      case DepositsStatusEnum.Pending:
        response = 'bg-no-balance-title-item';
        break;
      default:
        response = 'bg-default';
        break;
    }
    return response;
  }

  get showStepperBtn(): boolean {
    return this.activatedTab === this.tabsDeposits.Detail && !!this.getDepositFilteredAndSort().length;
  }

  get hasPoBoxValue(): boolean {
    return this.getCtrlByName('poboxlbl').value;
  }

  get totListFooter(): { totalLabel: string, totalAmountSelected: number }[] {
    return [
      { totalLabel: 'Total Credit:', totalAmountSelected: this.totalDepositAmountSelected },
      { totalLabel: 'Posted:', totalAmountSelected: this.totalDepositPostAmountSelected },
      { totalLabel: 'Adj:', totalAmountSelected: this.totalDepositAdjAmountSelected },
      { totalLabel: 'Diff:', totalAmountSelected: this.totalDiffSelected }
    ];
  }

  constructor(
    private fb: FormBuilder,
    protected objServ: ConciliationService,
    private titleService: Title,
    private sweetAlertHelper: SweetAlertHelper,
    private uploadsService: UploadsService,
    private t2LoadingService: T2LoadingService,
    private objToast: ToastrAlertHelper,
    protected inject: Injector
  ) {
    super('app-deposits', inject);
    this.createForm();
    this.gridBuilder();
    this.getDepositStatus();
    this.getAccountNumbers();
    this.initSubcriptions();
  }

  ngOnInit(): void {
    this.settingDropDown();
    this.getDepositbyCurrentMonth();
  }

  initSubcriptions(): void {
    this.subscriptions.push(
      this.$actions.subscribe({
        next: (value) => {
          if (value && value.length) {
            this.actionsDeposit = value;
            const includesDepositTab = value.includes(DepositActions.DepositTab);
            const includesDepositDetailTab = value.includes(DepositActions.DepositDetailTab);
            const includesLockBoxTab = value.includes(DepositActions.LockBoxTab);

            if (!includesDepositTab && includesLockBoxTab) {
              this.activatedTab = TabsDepositsEnum.LockBox;
              this.onChangeTabs(TabsDepositsEnum.LockBox);
            } else if (!includesDepositTab && includesDepositDetailTab && !includesLockBoxTab) {
              this.activatedTab = TabsDepositsEnum.Detail;
              this.onChangeTabs(TabsDepositsEnum.Detail);
            }
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.objServ.behaviorSubjDepositObs$.subscribe({
        next: (resp) => {
          if (resp && resp.data && resp.action === DepositAction.ChangeTabFromDetail) {
            switch (resp.data.value) {
              case TabsDepositsEnum.Deposits:
                this.activatedTab = resp.data.value;
                break;
              default:
                break;
            }
          } if (resp && resp.data && resp.data.deposit &&
                resp.action === DepositAction.ChangeTabFromConciliation
              ) {
            switch (resp.data.action) {
              case TabsDepositsEnum.Detail:
                this.activatedTab = TabsDepositsEnum.Detail;

                const deposit = resp.data.deposit;
                this.setterDepositDetailLabels(deposit);
                this.getPoBoxNumber(deposit.accountnumber);
                this.indexCountStepper = resp.data.indexCountStepper;

                if (this.gridDepositOptions && this.gridDepositOptions.api) {
                  this.gridDepositOptions.api.setRowData(resp.data.filteredDataAndSort);
                }
                this.filteredDataAndSort = resp.data.filteredDataAndSort;
                const depositId = Number(deposit.id);
                if (depositId && !isNaN(depositId)) {
                  this.getDepositHistory(depositId);
                }
                break;
              default:
                break;
            }

          } else if (resp && resp.data && resp.action === DepositAction.StepperActionButtonResp) {
            if (resp.data.value.nextDeposit && resp.data.value.stepperNumber) {
              this.nextDeposit(resp.data.value.stepperNumber);
            }
          } else if (resp && resp.data && resp.action === DepositAction.AutoFillActionButtonResp) {
            if (resp.data.value && resp.data.value.statusId) {
              const formData = this.depositSearchForm.getRawValue();
              const putReq = {
                idlbl: formData.idlbl,
                depositStatus: resp.data.value.statusId,
                note: this.notengmodel // formData.note
              };
              this.commitChanges(putReq);
            }
          } else if (resp && resp.action && resp.action === DepositAction.UpdateGridAfterCloseCopyPasteModal) {
            this.modalCopyPasteDepositDetails.close();
          } else if (resp && resp.action &&
            (
              resp.action === DepositAction.MonthPickerSetterValueChangesLockBoxResp ||
              resp.action === DepositAction.MonthPickerSetterValueChangesPostedResp ||
              resp.action === DepositAction.MonthPickerSetterValueChangesConciliationResp ||
              resp.action ===  DepositAction.MonthPickerSetterValueChangesElectronicResp
            )
          ) {
            if (resp.data) {
              this.depositSearchForm.get('depositdate').patchValue(resp.data, { emitEvent: false });
            }
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.depositSearchForm.get('depositdate')
      .valueChanges.subscribe({
        next: (res) => {
          if (res) {
            this.objServ.behaviorSubjDeposit.next({
              action: DepositAction.MonthPickerSetterValueChangesDeposit,
              data: res
            });
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      }),
      this.getCtrlByName('depositStatus').valueChanges
        .pipe(pairwise<number>())
        .subscribe({
          next: ([previous, _]) => (this.previousStatus = previous)
        })
    );
  }

  getDepositbyCurrentMonth(): void {
    this.depositSearchForm.get('depositdate').patchValue(moment().format('YYYY-MM-DD'), { emitEvent: false });
    this.depositSearchForm.get('depositdatelockbox').patchValue(moment().format('YYYY-MM-DD'));
    const request: IDeposit = {
      id: null,
      description: null,
      depositstatusids: [],
      depositdate: this.validDepositDate(moment())
    };
    this.searchDeposit(request);
  }

  settingDropDown(): void {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select ...',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: '',
      badgeShowLimit: 1
    };
    this.dropdownSettingsAccount =  {
      singleSelection: true,
      text: 'Select ...',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: '',
      badgeShowLimit: 1
    };
  }

  createForm(): void {
    this.depositSearchForm = this.fb.group({
      id: null,
      depositdate: null,
      depositdatelockbox: null,
      description: null,
      credit: 0,
      idlbl: null,
      accountnumberlbl: '',
      poboxlbl: null,
      depositdatelbl: null,
      descriptionlbl: '',
      creditlbl: '',
      statuslbl: '',
      depositslist: null,
      note: null,
      file: '',
      uploadfiles: '',
      depositStatus: null
    });

    this.depositForm = this.fb.group({
      accountnumber: [null, Validators.required],
      description: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      credit: [null, [Validators.required, Validators.pattern(this.noBlankSpace)]],
      depositdate: [null, Validators.required],
      depositstatusid: 1
    });

    this.showMisappliedDeposits = this.fb.control(false);
  }

  gridBuilder(): void {
    this.gridDepositHistory = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      columnDefs: [
        {
          headerName: 'Field',
          field: 'field',
          width: 100
        },
        {
          headerName: 'Old Value',
          field: 'oldvalue',
          width: 150,
          hide: true
        },
        {
          headerName: 'Old Value',
          field: 'oldvaluedescription',
          width: 150
        },
        {
          headerName: 'New Value',
          field: 'newvalue',
          width: 500,
          hide: true
        },
        {
          headerName: 'Old Value',
          field: 'newvaluedescription',
          width: 150
        },
        {
          headerName: 'Created Date',
          field: 'createdatdate',
          valueGetter: (params) => {
            if (params && params.data && params.data.createdatdate) {
              return CustomDate.formatJs(params.data.createdatdate);
            }
          }
        },
        {
          headerName: 'Created Time',
          field: 'createdattime'
        },
        {
          headerName: 'User Name',
          field: 'username'
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.gridDepositHistory && this.gridDepositHistory.api) {

          this.gridDepositHistory.api.setRowData([]);
          this.gridDepositHistory.api.sizeColumnsToFit();
        }
      }
    };

    this.gridDepositOptions = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'single',
      suppressRowClickSelection: true,
      frameworkComponents: {
        buttonRenderer: BtnCellRendererComponent
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 35,
          cellStyle: { 'text-align': 'end' }
        },
        {
          headerName: 'Account Number',
          field: 'accountnumber',
          width: 100,
          cellStyle: { 'text-align': 'start' },
        },
        {
          headerName: 'Deposit Date',
          field: 'depositdate',
          width: 100,
          valueGetter: (params) => {
            if (params && params.data.depositdate) {
              return CustomDate.formatJs(params.data.depositdate);
            }
          },
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'Description',
          field: 'description',
          cellStyle: { 'text-align': 'start' },
          width: 360
        },
        {
          headerName: 'Deposit id',
          field: 'depositstatusid',
          width: 5,
          hide: true
        },
        {
          headerName: 'Deposit Status',
          field: 'depositstatusdescription',
          width: 100,
          cellStyle: params => {
            const cellStyleObj = { 'text-align': 'start', color: 'black', 'font-weight' : 'normal' };
            if (params && params.data.depositstatusid) {
              switch (params.data.depositstatusid) {
                case DepositsStatusEnum.Pending:
                  cellStyleObj.color = 'red';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                case DepositsStatusEnum.Completed:
                  cellStyleObj.color = 'green';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                default:
                  break;
              }
            }
            return cellStyleObj;
          }
        },
        {
          headerName: 'Imported On',
          field: 'importedon',
          width: 40,
          hide: true,
          valueGetter: (params) => {
            if (params && params.data && params.data.importedon) {
              return CustomDate.formatJs(params.data.importedon);
            }
          },
          cellRenderer: (params) => {
            let ico = '';
            let wasImported = null;

            if (params && params.data && params.data.importedon) {
              ico = 'fa icofont-check color-success';
              wasImported = 'Imported';
            }

            return wasImported &&
            `<center>${params.data.importedon}
            <i class="${ico}" aria-hidden="true" style='font-size: 20px' title="${wasImported}"></i></center>`;
          }
        },
        {
          headerName: '#',
          field: 'depositdetailcount',
          cellStyle: { 'text-align': 'end' },
          width: 30
        },
        {
          headerName: 'Credit',
          field: 'credit',
          cellStyle: { 'text-align': 'end' },
          width: 120,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.credit
              ? '$' + params.data.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Posted Amt',
          field: 'totalpostedamt',
          cellStyle: { 'text-align': 'end' },
          width: 120,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.totalpostedamt
            ? '$' + params.data.totalpostedamt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Adj Amt',
          field: 'depositdetailadjustment',
          cellStyle: { 'text-align': 'end' },
          width: 100,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.depositdetailadjustment
              ? '$' + params.data.depositdetailadjustment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Diff',
          field: 'diff',
          cellStyle: { 'text-align': 'end' },
          width: 100,
          cellRenderer: (params) => {
            const decimal = 0;
            return params && params.data.diff
            ? '$' + params.data.diff.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : '$' + decimal.toFixed(2);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Actions',
          field: '',
          colId: 'action',
          cellRenderer: 'buttonRenderer',
          cellStyle: {
            color: 'red',
            'font-size': '15px',
            'text-align': 'center'
          },
          width: 40,
          hide: false,
          cellRendererParams: (params: any) => {
            if (params && params.data.id) {
              const OBJ_RETURN: BtnCellRendererI = {
                onClick: () => this.deleteRow(params),
                classFontAwesome: 'fa-trash',
                bgColor: '#fff',
                color: '#ee0000',
                title: `Delete Deposit #${params.data.id}`,
                border: '1px solid #ddd',
              };

              return OBJ_RETURN;
            } else {
              return {
                onClick: null,
                classFontAwesome: '',
                title: ``,
                showBtn: false,
              };
            }
          }
        },
        {
          headerName: 'Note',
          field: 'note',
          width: 100,
          hide: true
        }
      ],
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.gridDepositOptions.api) {
          this.gridDepositOptions.api.setRowData([]);
          this.subscribeToSwitchToIncludeMisappliedDeposits();
          this.gridDepositOptions.api.sizeColumnsToFit();
        }
      },
      onCellClicked: (event: CellClickedEvent) => {
        if (event && event.api) {
          event.api.clearFocusedCell();
        }
      },
      onRowClicked: (event) => {
        this.selectedRowIndex = event.data.id;
        this.gridDepositOptions.api.redrawRows();
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        this.t2LoadingService.show();
        if (params && params.data && params.data.id) {
          this.subscriptions.push(
            this.getDepositDetailWithoutSubs(params.data.id)
            .subscribe({
              next: (resp) => {
                this.setterDepositDetailLabels(params.data);
                if (resp && resp.length) {
                  this.insertRecords(resp);
                } else {
                  this.insertRecords([]);
                }
                this.indexCountStepper = (this.getCurrentIndex() + 1);
                this.onChangeTabs(this.tabsDeposits.Detail);
              },
              error: (er) => {
                this.sweetAlertHelper.captureException(er);
              }
            })
          );
        }
      },
      onFilterChanged: () => {
        this.selectedRowIndex = null;
        this.updateButtonState();
        this.gridDepositOptions.api.redrawRows();
      },
      onSortChanged: () => this.updateButtonState(),
      rowClassRules: {
        'row-default-deposit-grid': (params) => {
          return params.data.id !== null;
        },
        'row-selected-deposit': (params) => {
          return params && params.data && params.data.id === this.selectedRowIndex;
        }
      },
      getRowNodeId: (data) => data.id
    };
  }

  subscribeToSwitchToIncludeMisappliedDeposits(): void {
    this.subscriptions.push(
      this.showMisappliedDeposits
        .valueChanges
        .subscribe({
          next: (includesMisappliedDeposits) => {
            const gridApi: GridApi = this.gridDepositOptions.api;
            const filterModel = gridApi.getFilterModel();
            const sortModel = gridApi.getSortModel();

            const totalRows = includesMisappliedDeposits ? this.allDeposits.length : this.depositsWithoutMisapplied.length;
            const deposits = includesMisappliedDeposits ? this.allDeposits : this.depositsWithoutMisapplied;

            this.totalRows = totalRows;
            this.gridDepositOptions.api.setRowData(deposits);
            this.gridDepositOptions.api.setFilterModel(filterModel);
            this.gridDepositOptions.api.setSortModel(sortModel);

            this.getTotalDepositGrid(DepositGridName.DepositGrid, deposits);
          }
        })
    );
  }

  getCurrentIndex(): number {
    const filteredData: any[] = this.getDepositFilteredAndSort();
    const rowSelectedId = Number(this.getCtrlByName('idlbl').value);
    return filteredData.findIndex((depositRow: any) => depositRow.id === rowSelectedId);
  }

  setterDepositDetailLabels(params: any): void {
    this.getCtrlByName('idlbl').patchValue(params.id);
    this.getCtrlByName('accountnumberlbl').patchValue(params.accountnumber);
    const dateOut = moment(params.depositdate).format('YYYY-MM-DD');
    this.getCtrlByName('depositdatelbl').patchValue(dateOut);
    this.getCtrlByName('descriptionlbl').patchValue(params.description);
    this.getCtrlByName('creditlbl').patchValue(params.credit);
    this.getCtrlByName('statuslbl').patchValue(params.depositstatusdescription);
    this.getCtrlByName('depositStatus').patchValue(params.depositstatusid);
    this.getCtrlByName('note').patchValue(params.note);
    this.notengmodel = params.note;
    this.getPoBoxNumber(params.accountnumber);
  }

  getDepositSetter(depositId: number): void {
    const request: IDeposit = { id: depositId };
    this.subscriptions.push(
      this.getDepositObs(request)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (resp) => {
          if (resp && resp.length) {
            const depositData = resp.find(() => true);
            this.getCtrlByName('statuslbl').patchValue(depositData.depositstatusdescription);
            this.getCtrlByName('depositStatus').patchValue(depositData.depositstatusid);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  getCtrlByName(controlName: string): AbstractControl {
    return this.depositSearchForm.get(controlName);
  }

  insertRecords(records: any[]): void {
    const depoId = this.getCtrlByName('idlbl').value;
    const creditValue = this.getCtrlByName('creditlbl').value;
    if (depoId) {
      this.depositSearchForm.patchValue({ depositslist: { records, depositid: depoId, creditValue } });
    }
  }

  onChangeTabs(selectedTab: TabsDepositsEnum): void {
    switch (selectedTab) {
      case TabsDepositsEnum.Deposits:
        if (this.actionsDeposit.includes('DepositTab')) {
          this.changeTitle('Deposits');
          this.run(TabsDepositsEnum.Deposits);
          this.sendEventTab(DepositAction.ChangeTab, selectedTab);
          this.optionImport = OptionImportEnum.Deposits;
        }
        break;
      case TabsDepositsEnum.Detail:
        if (this.actionsDeposit.includes('DepositDetailTab')) {
          this.activatedTab = selectedTab;
          this.changeTitle('Details');
          const depositId = Number(this.getCtrlByName('idlbl').value);
          if (depositId && !isNaN(depositId)) {
            this.getDepositHistory(depositId);
          }
          this.optionImport = OptionImportEnum.Deposits;
        }
        break;
      case TabsDepositsEnum.LockBox:
        if (this.actionsDeposit.includes('LockBoxTab')) {
          this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchLogBox, data: true });
          this.activatedTab = selectedTab;
          this.changeTitle('LockBox');
          this.optionImport = OptionImportEnum.LockBox;
        }
        break;
      case TabsDepositsEnum.Posted:
        if (this.actionsDeposit.includes('PostedTab')) {
          this.objServ.resetElectronicId(true);
          this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchPosted, data: { filterOnlyPostedWriteOff: false } });
          this.activatedTab = selectedTab;
          this.changeTitle('Posted');
          this.optionImport = OptionImportEnum.Posted;
        }
        break;
      case TabsDepositsEnum.Conciliation:
        if (this.actionsDeposit.includes('ConciliationTab')) {
          this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchConciliation, data: true });
          this.activatedTab = selectedTab;
          this.changeTitle('Conciliation');
        }
        break;
      case TabsDepositsEnum.OfficeDeposit:
          if (this.actionsDeposit.includes('OfficeDepositTab')) {
            this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchOfficeDeposit, data: true });
            this.activatedTab = selectedTab;
            this.changeTitle('Office Deposit');
          }
          break;
      case TabsDepositsEnum.Electronic:
        if (this.actionsDeposit.includes('ElectronicTab')) {
          this.objServ.resetElectronicId(true);
          this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchElectronic, data: true });
          this.activatedTab = selectedTab;
          this.changeTitle('Electronic');
        }
        break;
      case TabsDepositsEnum.WriteOff:
        if (this.actionsDeposit.includes('WriteOffTab')) {
          this.objServ.behaviorSubjDeposit.next({ action: DepositAction.SearchPosted, data: { filterOnlyPostedWriteOff: true } });
          this.activatedTab = selectedTab;
          this.changeTitle('Write Offs');
          this.optionImport = OptionImportEnum.Posted;
        }
        break;
      default:
        break;
    }
  }

  createRateGroup(rowValue: any): FormGroup {
    return this.fb.group(rowValue);
  }

  private changeTitle(message: string) {
    this.titleService.setTitle(message);
    $('#main-header .page-title').html(message);
  }

  toggleTab(tabNumber: number): boolean {
    return (this.activatedTab === tabNumber);
  }

  validDepositDate(depositDate: any): string {
    const momentDate = moment(depositDate);
    return momentDate.isValid() ? momentDate.format('MM-YYYY') : null;
  }

  run(numberTab: number): void {
    switch (numberTab) {
      case TabsDepositsEnum.Deposits:
        if (this.validRunAction()) {
          this.totalDepositAmountSelected = 0;
          this.totalDepositPostAmountSelected = 0;
          this.totalDepositAdjAmountSelected = 0;
          this.totalDiffSelected = 0;

          const statusIds: number[] = this.statusSelectedList.map(row => row.id);
          const idSearch = this.getCtrlByName('id').value;
          const id = !isNaN(idSearch) ? Number(idSearch) : null;
          const request: IDeposit = {
            id: id,
            depositstatusids: statusIds.length ? statusIds : [],
            description: this.getCtrlByName('description').value,
            depositdate: this.validDepositDate(this.getCtrlByName('depositdate').value)
          };
          this.searchDeposit(request);
        } else {
          this.clearCountAndGrid();
          this.objToast.error('Action not allowed', 'Attention', { positionClass: 'toast-bottom-right' });
        }
        break;
      default:
        break;
    }
  }

  searchDeposit(req: IDeposit): void {
    this.selectedRowIndex = null;
    let filterModel: any = null, fortModel: any = null;

    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      filterModel = this.gridDepositOptions.api.getFilterModel();
      fortModel = this.gridDepositOptions.api.getSortModel();
    }
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.getDepositObs(req)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (resp) => {
          if (resp && resp.length) {
            this.allDeposits = resp;
            this.depositsWithoutMisapplied = resp.filter(el => el.depositstatusid !== DepositsStatusEnum.Misapplied);

            const showMisappliedDeposits: boolean = this.showMisappliedDeposits.value;
            const depositToShow: IDepositResponse[] = showMisappliedDeposits ? this.allDeposits : this.depositsWithoutMisapplied;

            this.totalRows = showMisappliedDeposits ? this.allDeposits.length : this.depositsWithoutMisapplied.length;

            if (this.gridDepositOptions && this.gridDepositOptions.api) {
              this.gridDepositOptions.api.setRowData(depositToShow);
              this.getTotalDepositGrid(DepositGridName.DepositGrid, depositToShow);
              if (filterModel) {
                this.gridDepositOptions.api.setFilterModel(filterModel);
              }
              if (fortModel) {
                this.gridDepositOptions.api.setSortModel(fortModel);
              }
              this.hideActionColumn();
            }
          } else {
            this.clearCountAndGrid();
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  getDepositObs(req: IDeposit): Observable<IDepositResponse[]> {
    return this.objServ.getDeposit(req);
  }

  clearLabels(): void {
    this.depositSearchForm.reset({
      id: null,
      accountnumber: null,
      depositdate: '',
      description: null,
      credit: 0,
      idlbl: null,
      accountnumberlbl: '',
      poboxlbl: null,
      depositdatelbl: null,
      descriptionlbl: '',
      creditlbl: '',
      statuslbl: '',
      depositslist: null,
      note: null
    });
  }

  getDepositStatus(): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getDepositStatus()
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (res) => {
          if (res) {
            this.initStatusList(res);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  getAccountNumbers(): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getAccountNumberList(false)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (res) => {
          if (res) {
            this.initAccountList(res);
          }
        },
        error: (er) => this.sweetAlertHelper.captureException(er)
      })
    );
  }

  clearDepositdate(controlName: string, hasModal = false): void {
    if (!hasModal) {
      this.depositSearchForm.get(controlName).patchValue('');
    } else {
      this.depositForm.get(controlName).patchValue('');
    }
  }

  initStatusList(data: any[]): void {
    this.clearSelectionStatus();
    const mappedList = this.mapListStatus(data);
    this.setStatusList(mappedList);
  }

  initAccountList(data: any[]): void {
    this.clearSelectionAccounts();
    const mappedList = this.mapListAccount(data);
    this.setAccountList(mappedList);
  }

  clearSelectionStatus() {
    this.statusSelectedList = [];
  }

  clearSelectionAccounts() {
    this.accountnumberSelectedList = [];
  }

  mapListStatus(data: any[]): { id: number, itemName: string }[] {
    return data.length ? data.map((p: any) => ({ id: p.depositstatusid, itemName: p.description })) : [];
  }

  mapListAccount(data: any[]): { id: number, itemName: string }[] {
    return data.length ? data.map((p: any) => ({ id: p.accountnumber, itemName: p.accountnumber })) : [];
  }

  setStatusList(list: any[]): void {
    this.depositStatusList = list;
  }

  setAccountList(list: any[]): void {
    this.accountList = list;
  }

  formatCurrency(controlName: string): string {
    const value = this.getCtrlByName(controlName).value;
    const formatVal = isNaN(Number(value)) ? 0 : Number(value);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }

  formatCurrencyText(valueFormated): string {
    const formatVal = isNaN(Number(valueFormated)) ? 0 : Number(valueFormated);
    return FormatCurrencyHelper.formatCurrency(formatVal);
  }

  selectedFiles(event: any): void {
    if (event && event.target && event.target.files && event.target.files.length) {
      let text = '';
      for (const name of event.target.files) {
        text += name.name + ', ';
      }
      this.depositSearchForm.patchValue({
        file: text,
        uploadfiles: event.target.files,
      });
    }
  }

  uploadFile(): void {
    if (this.fileSelected()) {
      this.sweetAlertHelper
      .createCustomAlert({
        title: 'Process File',
        text: 'Are you sure you want to process these deposits files?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, import it!',
        cancelButtonText: 'No, cancel!',
      })
      .then((result) => {
        if (result.value) {
          this.t2LoadingService.show();
          const uploadFiles = this.getCtrlByName('uploadfiles').value;
          const params = [{ nameParam: 'dataBodySpreadSheet', data: { extension: 'xls' } }];

          this.subscriptions.push(
            this.uploadsService
            .makeFileRequest(`${constant.URL_API_DEPOSIT_UPLOAD_FILE}?optionImport=${this.optionImport}`, params, uploadFiles, 'file')
            .subscribe({
              next: (resp) => {
                if (resp && (resp.totalinserted || resp.totalduplicates || resp.totaltoinsert)) {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Import File',
                    text: `Deposit Import Success`,
                    type: 'success',
                    html: `<div>Total Inserted: ${resp.totalinserted ? resp.totalinserted : 0 }</div>
                          <div>Total Duplicates: ${resp.totalduplicates ? resp.totalduplicates : 0}</div>
                          <div>Total: ${resp.totaltoinsert ? resp.totaltoinsert : 0}</div>`
                  }).then(() => {
                    this.t2LoadingService.hiden();
                    this.closeModalByName(this.modalDeposits.ImportFile);
                  });
                }
              },
              error: (er) => {
                this.t2LoadingService.hiden();
                this.sweetAlertHelper.captureException(er)
                .then(() => this.closeModalByName(this.modalDeposits.ImportFile));
              }
            })
          );
        }
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Import File',
        text: `Action no allowed`,
        type: 'error'
      }).then(() => {
        this.closeModalByName(ModalNameEnum.ImportFile);
      });
    }
  }

  getDepositHistory(depositId: number): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
    this.objServ.getDepositHistory(depositId)
    .finally(() => {
      this.t2LoadingService.hiden();
    })
    .subscribe({
      next: (resp) => {
        if (resp && resp.length) {
          this.gridDepositHistory.api.setRowData(resp);
        } else {
          this.gridDepositHistory.api.setRowData([]);
          this.notengmodel = null;
        }
      },
      error: () => {
        this.gridDepositHistory.api.setRowData([]);
        this.notengmodel = null;
      }
    }));
  }

  saveDeposit(): void {
    if (this.depositForm.valid) {
      this.sweetAlertHelper
      .createCustomAlert({
        title: 'New Deposit',
        text: 'Are you sure to create a deposit?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
      })
      .then((result) => {
        if (result.value) {
          this.t2LoadingService.show();
          const dataDepositForm = this.depositForm.getRawValue();
          const momentDate = moment(dataDepositForm.depositdate);
          const depositDate = momentDate.isValid() ? momentDate.format('YYYY-MM-DD') : null;

          const reqNewDeposit: IDeposit = {
            accountnumber: dataDepositForm.accountnumber,
            description: dataDepositForm.description,
            credit: isNaN(Number(dataDepositForm.credit)) ? 0 : Number(dataDepositForm.credit),
            depositdate: depositDate,
            depositstatusid: DepositsStatusEnum.Pending
          };

          this.subscriptions.push(
            this.objServ.saveDeposit(reqNewDeposit)
            .finally(() => this.t2LoadingService.hiden())
            .subscribe({
              next: (resp) => {
                if (resp && resp.id) {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Added deposit',
                    text: `Deposit has been successfully created, with ID: ${resp.id}`,
                    type: 'success'
                  }).then(() => {
                    const request: IDeposit = {
                      id: resp.id,
                      accountnumber: null,
                      depositstatusids: [],
                      description: null,
                      depositdate: null
                    };
                    this.getCtrlByName('depositdate').patchValue(null);
                    this.searchDeposit(request);
                    this.closeModalByName(ModalNameEnum.Deposits);
                    this.clearLabels();
                    this.getCtrlByName('id').patchValue(resp.id);
                    this.accountnumberSelectedList = [];
                  });
                }
              },
              error: (er) => {
                this.sweetAlertHelper.captureException(er);
              }
            })
          );
        }
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Added deposit',
        text: `Action no allowed`,
        type: 'error'
      }).then(() => {
        this.accountnumberSelectedList = [];
        this.resetDepositModal();
      });
    }
  }

  openModalByName(modalName: number): void {
    switch (modalName) {
      case ModalNameEnum.Deposits:
        this.accountnumberSelectedList = [];
        this.jsonDepositDate = null;
        this.resetDepositModal();
        this.modalAddDeposit.open();
        break;
      case ModalNameEnum.ImportFile:
        this.modalImportDeposit.open();
        break;
      case ModalNameEnum.CopyPasteDepositDetails:
        this.modalCopyPasteDepositDetails.open();
        this.objServ.behaviorSubjDeposit.next({
          action: DepositAction.OpenCopyPasteModal,
          data: { depositId: Number(this.getCtrlByName('idlbl').value) }
        });
        break;
      case ModalNameEnum.NoteDetails:
        if (this.idLblCtrl.value) {
          this.getDepositHistory(this.idLblCtrl.value);
        }
        this.showCancelButtonModal = true;
        this.modalDepositNote.open();
        break;
      case ModalNameEnum.HistoryDetails:
        if (this.idLblCtrl.value) {
          this.getDepositHistory(this.idLblCtrl.value);
        }
        this.modalDepositHistory.open();
        break;
      default:
        break;
    }
  }

  closeModalByName(modalName: number): void {
    switch (modalName) {
      case ModalNameEnum.Deposits:
        this.modalAddDeposit.close();
        break;
      case ModalNameEnum.ImportFile:
        this.resetImportFile();
        this.modalImportDeposit.close();
        break;
      case ModalNameEnum.NoteDetails:
        this.reasonChangeStatus = '';
        this.modalDepositNote.close();
        break;
      case ModalNameEnum.HistoryDetails:
        this.modalDepositHistory.close();
        break;
      default:
        break;
    }
  }

  closeDepositStatusNoteModal(): void {
    this.modalDepositNote.close();

    if (this.resetDepositStatus) {
      this.getCtrlByName('depositStatus').patchValue(this.previousStatus);
    }

    this.resetDepositStatus = false;
  }

  resetDepositModal(): void {
    this.depositForm.reset({
      accountnumber: '',
      description: null,
      credit: null,
      depositdate: null,
      depositstatusid: null
    });
  }

  saveChangeStatus($event: any): void {
    if ($event && this.getCtrlByName('depositStatus').value) {
      const formData = this.depositSearchForm.getRawValue();
      if (formData && this.countDiff(formData) !== 0 && formData.depositStatus === DepositsStatusEnum.Completed) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Confirm',
          text: 'Are you sure to complete a deposit that has not been zero balanced?',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonColor: '#dc3545',
          confirmButtonColor: '#1464f6',
          confirmButtonText: 'Yes!',
          cancelButtonText: 'No!'
        })
        .then((res) => {
          if (res && res.value) {
            this.showCancelButtonModal = false;
            this.modalDepositNote.open();
          } else {
            this.getCtrlByName('depositStatus').patchValue(this.previousStatus);
          }
        });
      } else {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Confirm',
          text: 'Do you want to add a note to the status change?',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonColor: '#dc3545',
          confirmButtonColor: '#1464f6',
          confirmButtonText: 'Yes, add note and save!',
          cancelButtonText: 'Save without adding note!'
        })
        .then((re: any) => {
          if (re && re.value) {
            this.showCancelButtonModal = true;
            this.resetDepositStatus = true;
            this.modalDepositNote.open();
          } else {
            switch (re.dismiss) {
              case EventModal.Cancel:
                this.commitChanges(formData);
                break;
              case EventModal.Close:
              case EventModal.Overlay:
                this.getCtrlByName('depositStatus').patchValue(this.previousStatus);
                break;
              default:
                break;
            }
          }
        });
      }
    } else {
      this.getCtrlByName('depositStatus').patchValue(this.previousStatus);
    }
  }

  countDiff(formData: any): number {
    let countDiff = 0;
    if (formData && formData.depositslist.length) {
      formData.depositslist.forEach(row => {
        countDiff += isNaN(Number(row.diff)) ? 0 : Number(row.diff);
      });
    }
    return countDiff;
  }

  commitChanges(formData: any): void {
    if (formData.idlbl && formData.depositStatus) {
      this.t2LoadingService.show();
      const putReq = {
        isactive: true,
        id: formData.idlbl,
        accountnumber: this.getCtrlByName('accountnumberlbl').value,
        description: this.getCtrlByName('descriptionlbl').value,
        credit: this.getCtrlByName('creditlbl').value,
        depositdate: this.getCtrlByName('depositdatelbl').value,
        depositstatusid: formData.depositStatus,
        note: this.notengmodel // formData.note
      };
      this.objServ.updateDeposit(putReq)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (res) => {
          if (res && res.message) {
            this.objToast.success(res.message, 'Deposit Update', { positionClass: 'toast-bottom-right' });
            const depositId = Number(this.getCtrlByName('idlbl').value);
            if (depositId) {
              this.getDepositSetter(depositId);
              this.getDepositHistory(depositId);
              if (res && res.data && res.data.id) {
                const depositRow = this.filteredDataAndSort.find(row => row.id === res.data.id);
                if (depositRow) {
                  depositRow.note = res.data.note;
                }
              }
            }

            if (res.data && this.filteredDataAndSort && this.filteredDataAndSort.length) {
              const index = this.filteredDataAndSort.findIndex(item => item.id === res.data.id);
              if (index !== -1) {
                this.filteredDataAndSort[index].depositstatusid = res.data.depositstatusid;
                this.getCtrlByName('depositStatus').patchValue(res.data.depositstatusid);
              }
            }
          }
        },
        error: (er) => {
          this.sweetAlertHelper.captureException(er);
        }
      });
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Status change',
        text: `Action not allowed`,
        type: 'error'
      });
    }
  }

  onDateExportSelectedFromTo(event: any): void {
    if (event && event.formatted) {
      const dateOut = event.formatted;
      this.depositForm.get('depositdate').patchValue(dateOut, { emitEvent: false });
    } else {
      this.depositForm.get('depositdate').patchValue(null, { emitEvent: false });
    }
  }

  fileSelected(): boolean {
    return this.filesNamesCtrl.value !== '';
  }

  resetImportFile(): void {
    this.fileInput.nativeElement.value = '';
    this.depositSearchForm.patchValue({ file: '', uploadfiles: ''});
  }

  resetChangeStatusNote(event: any): void {
    if (event && event.isOpen) {
      this.reasonChangeStatus = '';
    }
  }

  validRunAction(): boolean {
    const idSearch = this.getCtrlByName('id').value;
    const id = !isNaN(idSearch) ? Number(idSearch) : null;
    const statusIds = this.statusSelectedList.map(row => row.id);
    const depositstatusids = statusIds.length ? statusIds : [];
    const description = this.getCtrlByName('description').value;
    const depositdate = this.validDepositDate(this.getCtrlByName('depositdate').value);

    return id || depositstatusids.length || description || depositdate;
  }

  validRunActionLockBox(): boolean {
    const depositDateLockBox = this.getCtrlByName('depositdatelockbox').value;
    return depositDateLockBox;
  }

  autoFillDetail(): void {
    if (this.showAutoFillButton) {
      this.sweetAlertHelper
      .createCustomAlert({
        title: 'Auto Fill',
        text: 'Are you sure you will execute this action?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
      .then((result) => {
        if (result.value) {
          const checkNumber = this.extractCheckNumber(this.getCtrlByName('descriptionlbl').value);
          if (checkNumber) {
            const rowToInsert = {
              checkdate: this.getCtrlByName('depositdatelbl').value,
              checknbr: checkNumber,
              amount: this.getCtrlByName('creditlbl').value
            };
            const depoId = this.getCtrlByName('idlbl').value;
            const currentStatusId = this.getCtrlByName('depositStatus').value;
            if (depoId) {
              this.sendEventTab(DepositAction.AutoFillActionButton, {
                pushRow: rowToInsert,
                depositid: depoId,
                currentStatusId
              });
            }
          } else {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Auto Fill',
              text: `Check number could not be extracted from description`,
              type: 'error'
            });
          }
        }
      });
    }
  }

  autoFillPayorDetail(): void {
    if (!this.showAutoFillPayorButton) { return; };

    this.sendEventTab(
      DepositAction.AutoFillDetailPayor,
      { depositId: this.getCtrlByName('idlbl').value  }
    );
  }

  extractCheckNumber(text: string): string {
    const regex = /TRN\*1\*([^*]+)\*/;
    const match = text.match(regex);
    return match ? match[1] : null;
  }

  getTotalDepositGrid(objTable: string, dataSource: any[]): void {
    switch (objTable) {
      case DepositGridName.DepositGrid:
        if (dataSource && dataSource.length) {
          const totCreditVal = dataSource.reduce((sum, item) => sum + item.credit, 0);
          const totPostedAmt = dataSource.reduce((sum, item) => sum + item.totalpostedamt, 0);
          const totAdjAmt = dataSource.reduce((sum, item) => sum + item.depositdetailadjustment, 0);
          const totDiff = dataSource.reduce((sum, item) => sum + item.diff, 0);

          this.totalCredit = totCreditVal;
          this.totalPostedAmt = totPostedAmt;
          this.totalAdjAmt = totAdjAmt;
          this.totalDiffAmount = totDiff;

          this.totalDepositAmountSelected = totCreditVal;
          this.totalDepositPostAmountSelected = totPostedAmt;
          this.totalDepositAdjAmountSelected = totAdjAmt;
          this.totalDiffSelected = totDiff;
        }
        break;
      default:
        break;
    }
  }

  sendEventTab(actionName: string, value: any): void {
    this.objServ.behaviorSubjDeposit.next({ action: actionName, data: { value } });
  }

  hideOption(tabNumber: number, condition = false): string {
    return this.toggleTab(tabNumber) || condition ? 'd-none-el' : 'd-block-el';
  }

  stepperDeposit(stepperNumber: number): void {
    this.sendEventTab(DepositAction.StepperActionButton, { nextDeposit: true, stepperNumber, depositId: 1 });
  }

  getDepositFilteredAndSort(): any[] {
    this.filteredDataAndSort = [];
    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      this.gridDepositOptions.api.forEachNodeAfterFilterAndSort(node => this.filteredDataAndSort.push(node.data));
    }
    return this.filteredDataAndSort;
  }

  downloadAccountSummaryReport(): void {
    const deposits: IDepositResponse[] = this.getDepositFilteredAndSort();
    if (!(deposits && deposits.length)) {
      this.objToast.error('There are no deposits to export', 'Attention', { positionClass: 'toast-bottom-right' });
      return;
    }
    const depositIds: number[] = deposits.map((deposit: IDepositResponse) => deposit.id);
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.objServ.getAccountSummaryReport(depositIds)
        .finally(() => {
          this.t2LoadingService.hiden();
        })
        .subscribe({
          next: (file: Blob) => {
            this.downloadAccountSummaryReportFile(file);
          },
          error: (er) => {
            this.sweetAlertHelper.captureException(er);
          }
        })
    );
  }

  private downloadAccountSummaryReportFile(blob: Blob): void {
    const today: string = CustomDate.formatFromObject(CustomDate.toDateObject(new Date()), 'MM-dd-yyyy') || '';
    const downloadUrl: string = URL.createObjectURL(blob);
    const anchor: HTMLAnchorElement = document.createElement('a');
    anchor.href = downloadUrl;
    anchor.download = `Deposits_Account_Summary_${today}.xls`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(downloadUrl);
  }

  bulkSave(): void {
    if (this.notengmodel) {
      const formData = this.depositSearchForm.getRawValue();
      formData.note = this.notengmodel;
      this.commitChanges(formData);
    }
    this.sendEventTab(DepositAction.BulkSave, TabsDepositsEnum.Detail);
  }

  saveDepositNote(): void {
    if (this.notengmodel) {
      const formData = this.depositSearchForm.getRawValue();
      formData.note = this.notengmodel;
      this.commitChanges(formData);
      this.closeModalByName(ModalNameEnum.NoteDetails);
    }
  }

  clearFilterAndSort(nameBtn: AgButtonsEnum): void {
    this.selectedRowIndex = null;
    switch (nameBtn) {
      case AgButtonsEnum.RemoveFilter:
        this.totalDepositAmountSelected = this.totalCredit;
        this.totalDepositPostAmountSelected = this.totalPostedAmt;
        this.totalDepositAdjAmountSelected = this.totalAdjAmt;
        this.totalDiffSelected = this.totalDiffAmount;
        this.gridDepositOptions.api.setFilterModel(null);
        break;
      case AgButtonsEnum.RemoveSort:
        this.gridDepositOptions.api.setSortModel(null);
        break;
      default:
        break;
    }
    this.updateButtonState();
  }

  updateButtonState(): void {
    const filterApply = !Object.keys(this.gridDepositOptions.api.getFilterModel()).length;
    this.enableClearFilter = filterApply;
    this.enableClearSort = !this.gridDepositOptions.api.getSortModel().length;

    if (!filterApply) {
      this.sumTotalDepositSelected();
    }
  }

  nextDeposit(stepperNumber: number): void {
    if (!!this.getDepositFilteredAndSort().length) {
      const currentIndex = this.getCurrentIndex();
      const startIndex = 0;
      const endIndex = this.filteredDataAndSort.length - 1;

      let indexControl = null;
      switch (stepperNumber) {
        case StepperEnum.Start:
          indexControl = 0;
          break;
        case StepperEnum.Previous:
          indexControl = (currentIndex - 1);
          break;
        case StepperEnum.Next:
          indexControl = (currentIndex + 1);
          break;
        case StepperEnum.End:
          indexControl = endIndex;
          break;
        default:
          break;
      }

      if (indexControl !== null && indexControl >= startIndex && indexControl <= endIndex) {
        this.t2LoadingService.show();
        this.indexCountStepper = indexControl + 1;
        const nextRow = this.filteredDataAndSort[indexControl];
        this.setterDepositDetailLabels(nextRow);

        this.getDepositDetailWithoutSubs(nextRow.id)
        .subscribe({
          next: (resp) => {
            if (resp && resp.length) {
              this.insertRecords(resp);
            } else {
              this.insertRecords([]);
            }
            this.onChangeTabs(this.tabsDeposits.Detail);
          }
        });
      } else {
        this.objToast.error('Deposit not found', 'Attention', { positionClass: 'toast-bottom-right' });
      }
    } else {
      this.objToast.error('Action not allowed', 'Attention', { positionClass: 'toast-bottom-right' });
    }
  }

  sumTotalDepositSelected(): void {
    let total = 0;
    let totalPostedAmt = 0;
    let totalAdjAmt = 0;
    let totalDiff = 0;

    this.gridDepositOptions.api.forEachNodeAfterFilterAndSort((node) => {
      if (node && node.data) {
        if (node.data.credit) {
          total += node.data.credit;
        }

        if (node.data.totalpostedamt) {
          totalPostedAmt += node.data.totalpostedamt;
        }

        if (node.data.depositdetailadjustment) {
          totalAdjAmt += node.data.depositdetailadjustment;
        }

        if (node.data.diff) {
          totalDiff += node.data.diff;
        }
      }
    });
    this.totalDepositAmountSelected = total;
    this.totalDepositPostAmountSelected = totalPostedAmt;
    this.totalDepositAdjAmountSelected = totalAdjAmt;
    this.totalDiffSelected = totalDiff;
  }

  getDepositDetailWithoutSubs(depositId: number): Observable<any> {
      return this.objServ.getDetail(depositId).finally(() => this.t2LoadingService.hiden());
  }

  clearCountAndGrid(): void {
    if (this.gridDepositOptions && this.gridDepositOptions.api) {
      this.totalDepositAmountSelected = 0;
      this.totalDepositPostAmountSelected = 0;
      this.totalDepositAdjAmountSelected = 0;
      this.totalDiffSelected = 0;
      this.gridDepositOptions.api.setRowData([]);
      this.totalRows = 0;
    }
  }

  deleteRow(event: any): void {
    if (this.actionsDeposit.includes(DepositActions.DepositDelete)) {
      if (event && event.colDef && event.colDef.colId === 'action') {
        if (event.data && event.data.id) {
          this.t2LoadingService.show();
          this.subscriptions.push(
            this.objServ.deleteDeposit(event.data.id)
            .finally(() => this.t2LoadingService.hiden())
            .subscribe({
              next: (res) => {
                if (res && res.message) {
                  this.gridDepositOptions.api.removeItems([event.node]);
                  this.objToast.success(res.message, 'Success!', { positionClass: 'toast-bottom-right' });
                }
              },
              error: (err) => this.sweetAlertHelper.captureException(err)
            })
          );
        }
      }
    } else {
      this.objToast.error('You do not have permission to perform this action', 'Access Denied!',
        { positionClass: 'toast-bottom-right' });
    }
  }

  hideActionColumn(): void {
    if (this.gridDepositOptions && this.gridDepositOptions.columnApi) {
      const depositDeleteAction = this.actionsDeposit.includes(DepositActions.DepositDelete);
      this.gridDepositOptions.columnApi.setColumnVisible('action', depositDeleteAction);
    }
  }

  onAccountNumberChange(): void {
    const accountNumber = this.accountnumberSelectedList.length ? this.accountnumberSelectedList.find(() => true) : null;
    if (accountNumber && accountNumber.id) {
      this.accountNumberFormCtrl.patchValue(accountNumber.id);
    } else {
      this.accountNumberFormCtrl.patchValue(null);
    }
  }

  getPoBoxNumber(accountnumber: any): void {
    this.t2LoadingService.show();
    if (accountnumber) {
      this.subscriptions.push(
        this.objServ.getPoBox(accountnumber)
        .finally(() => this.t2LoadingService.hiden())
        .subscribe({
          next: (resp) => {
            let poBoxVal = null;
            if (resp) {
              poBoxVal = resp;
            }
            this.getCtrlByName('poboxlbl').patchValue(poBoxVal);
          },
          error: (er) => this.sweetAlertHelper.captureException(er)
        })
      );
    }
  }

  get inputCheckShowMisappliedDepositsText(): string {
    return this.showMisappliedDeposits.value ? 'Exclude Misapplied' : 'Include Misapplied';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/deposits.component.ts